import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

import HomeIndex from './Components/HomePage/HomeIndex';

// projects detailed Route
import SumadhuraEdition from './Components/Projects/SumadhuraEdition';
import RivieraNorthEdition from './Components/Projects/RivieraNorthEdition';
import RiveraEdition from './Components/Projects/RiveraEdition';
import BescomTransfer from './Components/HomePage/BescomTransfer';
import RentalIndex from './Components/HomePage/Rental/RentalIndex';
import ContactUsIndex from './Components/ContactUs/ContactUsIndex';
import PropertyManagementIndex from './Components/PropertyManagement/PropertyManagementIndex';
import RentalFurnituresIndex from './Components/RentalFurnitures/RentalFurnituresIndex';
import PaintingIndex from './Components/Painting/PaintingIndex';
// Rentals detailed Route
import GoyalOrchid from './Components/RentalsDetailed/Goyalorchid';

// Projects detailed Route
import PoulomiFlorique from './Components/ProjectDetailedPages/Floriqueprojectpage';
import SobhaOneWorld from './Components/ProjectDetailedPages/Sobhaoneworldpage';

// Rental Agreements Route
import RentalAgreementsIndex from './Components/RentalAgreements/RentalAgreementsIndex';
import EKhathaIndex from './Components/EKhatha/EKhathaIndex';

// First Section Projects detailed Route
import BrigadeGranada from './Components/ProjectDetailedPages/PropertyDetailsbengaluruFirstSection/BrigadeGranada';
import PremiumFrenchRowhouses from './Components/ProjectDetailedPages/PropertyDetailsbengaluruFirstSection/PremiumFrenchRowhouses';
import SanjeeviniHeliconia from './Components/ProjectDetailedPages/PropertyDetailsbengaluruFirstSection/SanjeeviniHeliconia';

// Action Hub Routes (Buy, Rent, Lease, Sell)
import BuyIndex from './Components/Buy/BuyIndex';
import RentIndex from './Components/Rent/RentIndex';
import LeaseIndex from './Components/Lease/LeaseIndex';
import SellIndex from './Components/Sell/SellIndex';

// Services & Gallery Routes
import ServicesIndex from './Components/Services/ServicesIndex';
import GalleryIndex from './Components/Gallery/GalleryIndex';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // remove this line if you want instant scroll
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <>
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<HomeIndex />} />
        <Route path="/buy" element={<BuyIndex />} />
        <Route path="/rent" element={<RentIndex />} />
        <Route path="/lease" element={<LeaseIndex />} />
        <Route path="/sell" element={<SellIndex />} />
        <Route path="/post-ad" element={<SellIndex />} />
        <Route path="/sumadhura-edition" element={<SumadhuraEdition />} />
        <Route path="/riviera-north-edition" element={<RivieraNorthEdition />} />
        <Route path="/rivera-edition" element={<RiveraEdition />} />
        <Route path="/goyal-orchid" element={<GoyalOrchid />} />
        <Route path="/bescom-transfer" element={<BescomTransfer />} />
        <Route path="/rental-agreements" element={<RentalAgreementsIndex />} />
        <Route path="/e-khata" element={<EKhathaIndex />} />
        <Route path="/rent-sale" element={<RentalIndex />} />
        <Route path="/contact-us" element={<ContactUsIndex />} />
        <Route path="/services" element={<ServicesIndex />} />
        <Route path="/gallery" element={<GalleryIndex />} />
        <Route path="/projects" element={<GalleryIndex initialCategory="apartments" />} />
        <Route path="/property-management" element={<PropertyManagementIndex />} />
        <Route path="/rental-furnitures" element={<RentalFurnituresIndex />} />
        <Route path="/painting-services" element={<PaintingIndex />} />


        {/* Projects detailed Route */}
        <Route path="/poulomi-florique" element={<PoulomiFlorique />} />
        <Route path="/sobha-one-world" element={<SobhaOneWorld />} />

        {/* First Section Projects detailed Route */}
        <Route path="/brigade-granada" element={<BrigadeGranada />} />
        <Route path="/premium-french-rowhouses" element={<PremiumFrenchRowhouses />} />
        <Route path="/sanjeevini-heliconia" element={<SanjeeviniHeliconia />} />
      </Routes>
    </>
  );
}

export default App;